import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, MerchantActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(merchantsSelector);

    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    // 一覧のフィルタリング要素の復元用
    var merchantName = props.merchantName;  // 加盟店名
    var status = props.status;              // ステータス

    const listDefinition = {
        columns: [
            {
                // 加盟店
                title: <FormattedMessage id="Merchant.Title" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantName,
            },
            {
                // ステータス
                title: <FormattedMessage id="Merchant.Status" />,
                field: 'status',
                lookup: {
                     1: "申請",
                     2: "審査OK",
                     3: "登録完了",
                     4: "解約申請",
                     5: "解約",
                },
                filtering: true,
                defaultFilter: props.status,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {
        merchantName = '';
        status = '';

        // フィルタリング内容を退避
        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'merchant_name') {
                    merchantName = filter[i].value;
                } else if (filter[i].column.field == 'status') {
                    status = filter[i].value;
                }
            };
        }
    }

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 初期レンダリングの時のみ店舗一覧を取得
        if (props.refresh == null || props.refresh == true) {
            // storeに店舗リストを要求
            // 加盟店一覧を取得
            merchantActions.listMerchants(token)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    }, []);

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        console.log(data);
        // 選択された行と復元用に変更されたフィルタリング要素を返却
        props.onDetail(data, merchantName, status);
    }

    /**
     * 
     * 新規ボタン押下時の処理
     * 
     */
    const onCreateClick = (data) => {
        // 復元用に変更されたフィルタリング要素を返却
        props.onCreate(merchantName, status);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.Title" />}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（新規追加ボタン、詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            return (
                                <Button onClick={() => onCreateClick()} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} >
                                    <FormattedMessage id="Merchant.Create" />
                                </Button>
                            )
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantList);
